/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formphonenumber_Label2Inputs */

const ja_contact_formphonenumber_label2 = /** @type {(inputs: Contact_Formphonenumber_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電話番号`)
};

const en_contact_formphonenumber_label2 = /** @type {(inputs: Contact_Formphonenumber_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Phone Number`)
};

/**
* | output |
* | --- |
* | "Your Phone Number" |
*
* @param {Contact_Formphonenumber_Label2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formphonenumber_label2 = /** @type {((inputs?: Contact_Formphonenumber_Label2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formphonenumber_Label2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formphonenumber_label2(inputs)
	return en_contact_formphonenumber_label2(inputs)
});
export { contact_formphonenumber_label2 as "contact_formPhoneNumber_label" }